<template>
  <ul class="sidebar-menu">
    <router-link tag="li" class="pageLink treeview" to="/">
      <a class="treeview-link">
        <i class="fa fa-desktop"></i>
        <span class="page treeview-title">Dashboard</span>
      </a>
    </router-link>

    <li class="treeview" v-if="this.$store.getters.modules.includes(',11.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-user" aria-hidden="true"></i>
        <span class="treeview-title">Event Management</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open"
            v-if="this.$store.getters.modules.includes('11.01')"
        >
          <a href="#">
            Event Management
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/eventReport"
                           class="pageLink" v-if="this.$store.getters.modules.includes('11.01')">
                <a>Report</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>

    <li class="treeview" v-if="this.$store.getters.modules.includes(',21.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-user" aria-hidden="true"></i>
        <span class="treeview-title">Master</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open"
            v-if="this.$store.getters.modules.includes('21.1')||
        this.$store.getters.modules.includes('21.2')"
        >
          <a href="#">
            Master
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/adminOrganization"
                           class="pageLink" v-if="this.$store.getters.modules.includes('21.1')">
                <a>Organization</a>
              </router-link>
            </li>allUser
            <li>
              <router-link to="/adminUser"
                           class="pageLink" v-if="this.$store.getters.modules.includes('21.2')">
                <a>Admin User</a>
              </router-link>
            </li>
            <li>
              <router-link to="/allUser"
                           class="pageLink" v-if="this.$store.getters.modules.includes('21.2')">
                <a>All User List</a>
              </router-link>
            </li>
            <li>
              <router-link to="/adminInquiry"
                           class="pageLink" v-if="this.$store.getters.modules.includes('21.3')">
                <a>Admin Inquiry</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>


    <li class="treeview" v-if="this.$store.getters.modules.includes(',1.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-user"></i>
        <span class="treeview-title">Master</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('1.01') ||
        this.$store.getters.modules.includes('1.02') ||
        this.$store.getters.modules.includes('1.03') ||
        this.$store.getters.modules.includes('1.04') ||
        this.$store.getters.modules.includes('1.05') ||
        this.$store.getters.modules.includes('1.06') ||
        this.$store.getters.modules.includes('1.07') ||
        this.$store.getters.modules.includes('1.08')">
          <a href="#">
            Account
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/accountGroup" v-if="this.$store.getters.modules.includes('1.01')">
                <a>Account Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/accountSubGroup" v-if="this.$store.getters.modules.includes('1.02')">
                <a>Account Sub Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/accountSubGroupChild" v-if="this.$store.getters.modules.includes('1.02')">
                <a>Account Child Sub Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/accountmaster" v-if="this.$store.getters.modules.includes('1.03')">
                <a href="#">General Account Master</a>
              </router-link>
            </li>
            <li>
              <router-link to="/supplieraccount" v-if="this.$store.getters.modules.includes('1.04')">
                <a href="#">Supplier Account</a>
              </router-link>
            </li>
            <li>
              <router-link to="/customeraccount" v-if="this.$store.getters.modules.includes('1.05')">
                <a>Customer Account</a>
              </router-link>
            </li>
            <li>
              <router-link to="/CustomerFollowUpList" v-if="this.$store.getters.modules.includes('1.23')">
                <a>Customer FollowUp Accounts</a>
              </router-link>
            </li>
            <li>
              <router-link to="/bankDetail" v-if="this.$store.getters.modules.includes('1.06')">
                <a>Bank Account</a>
              </router-link>
            </li>
            <li>
              <router-link to="/incomeaccount" v-if="this.$store.getters.modules.includes('1.07')">
                <a>Income Account</a>
              </router-link>
            </li>
            <li>
              <router-link to="/expensesaccount" v-if="this.$store.getters.modules.includes('1.08')">
                <a>Expenses Account</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open"
            v-if="this.$store.getters.modules.includes('1.09') ||
        this.$store.getters.modules.includes('1.11') ||
        this.$store.getters.modules.includes('1.12') ||
        this.$store.getters.modules.includes('1.13') ">
          <a href="#">
            Inventory
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/itemgroup" v-if="this.$store.getters.modules.includes('1.09')">
                <a>Item Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemsubgroup" v-if="this.$store.getters.modules.includes('1.11')">
                <a>Item Sub Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/measurementunit" v-if="this.$store.getters.modules.includes('1.13')">
                <a href="#">Measurement Unit</a>
              </router-link>
            </li>
            <li>
              <router-link to="/unitConversion" v-if="this.$store.getters.modules.includes('1.18')">
                <a href="#">Unit Conversion</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemmaster" v-if="this.$store.getters.modules.includes('1.12')">
                <a href="#">General Item Master</a>
              </router-link>
            </li>
            <!-- <li>
              <a href="#">Item Group Report</a>
            </li> -->

          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('1.14') ||
        this.$store.getters.modules.includes('1.15') ">
          <a href="#">
            Store
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/warehousegroup" v-if="this.$store.getters.modules.includes('1.14')">
                <a>Store Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/warehouse" v-if="this.$store.getters.modules.includes('1.15')">
                <a>Store Master</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('1.16') ||
        this.$store.getters.modules.includes('1.17') ">
          <a href="#">
            Bill Sundry
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/billsundrypurchase" v-if="this.$store.getters.modules.includes('1.16')">
                <a> Bill Sundry on Purchase</a>
              </router-link>
            </li>
            <li>
              <router-link to="/billsundrysales" v-if="this.$store.getters.modules.includes('1.17')">
                <a>Bill Sundry on Sales</a>
              </router-link>
            </li>
            <li>
              <router-link to="/transportationDetails" v-if="this.$store.getters.modules.includes('1.24')">
                <a>Transportation Details</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('1.19') ||
        this.$store.getters.modules.includes('1.21')|| this.$store.getters.modules.includes('1.22') ">
          <a href="#">
            Cost Center
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/costCenterGroup" v-if="this.$store.getters.modules.includes('1.19')">
                <a> Cost Center Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/costCenterSubGroup" v-if="this.$store.getters.modules.includes('1.21')">
                <a>Cost Center Subgroup</a>
              </router-link>
            </li>
            <li>
              <router-link to="/costCenterSetup" v-if="this.$store.getters.modules.includes('1.22')">
                <a> Cost Center Setup</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="this.$store.getters.modules.includes(',2.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-calculator" aria-hidden="true"></i>
        <span class="treeview-title">Transaction</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('2.01') ||
        this.$store.getters.modules.includes('2.02') ||
        this.$store.getters.modules.includes('2.03') ||
        this.$store.getters.modules.includes('2.04') ||
        this.$store.getters.modules.includes('2.05')   ">
          <a href="#">
            Account
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/journal" v-if="this.$store.getters.modules.includes('2.01')">
                <a>Journal</a>
              </router-link>
            </li>
            <li>
              <router-link to="/payment" v-if="this.$store.getters.modules.includes('2.02')">
                <a>Payment</a>
              </router-link>
            </li>
            <li>
              <router-link to="/receipt" v-if="this.$store.getters.modules.includes('2.03')">
                <a>Receipt</a>
              </router-link>
            </li>
            <li>
              <router-link to="/debitnote" v-if="this.$store.getters.modules.includes('2.04')">
                <a>Debit Note (w/o items)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/creditnote" v-if="this.$store.getters.modules.includes('2.05')">
                <a>Credit Note (w/o items)</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('2.06') ||
        this.$store.getters.modules.includes('2.07') ||
        this.$store.getters.modules.includes('2.08') ||
        this.$store.getters.modules.includes('2.09') ||
        this.$store.getters.modules.includes('2.26') ||
        this.$store.getters.modules.includes('2.21') ">
          <a href="#">
            Sales
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <!-- <li>
             <router-link to="/stockTransforInternal" v-if="this.$store.getters.modules.includes('2.21')">
               <a>Stock Transfor (Internal)</a>
             </router-link>
           </li> -->
            <li>
              <router-link to="/salesorder" v-if="this.$store.getters.modules.includes('2.06')">
                <a>Sales Order</a>
              </router-link>
            </li>
            <li>
              <router-link to="/saleschallan" v-if="this.$store.getters.modules.includes('2.07')">
                <a>Sales Challan</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesinvoice" v-if="this.$store.getters.modules.includes('2.08')">
                <a>Sales Invoice</a>
              </router-link>
            </li>

            <li>
              <router-link to="/dairySalesInvoice" v-if="this.$store.getters.modules.includes('2.26')">
                <a>Dairy Sales Invoice</a>
              </router-link>
            </li>

            <li>
              <router-link to="/salesreturn" v-if="this.$store.getters.modules.includes('2.09')">
                <a>Sales Return(Cr. Note)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesReturnBillWise" v-if="this.$store.getters.modules.includes('2.18')">
                <a>Sales Return Billwise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/consumption" v-if="this.$store.getters.modules.includes('2.22')">
                <a>Consumption</a>
              </router-link>
            </li>
            <li>
              <router-link to="/damage" v-if="this.$store.getters.modules.includes('2.23')">
                <a>Damage</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('2.21') ">
          <a href="#">
            Stock Transfer
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/stockTransferInternal" v-if="this.$store.getters.modules.includes('2.21')">
                <a>Stock Transfer (Internal)</a>
              </router-link>
            </li>

          </ul>
        </li>

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('2.11') ||
        this.$store.getters.modules.includes('2.12') ||
        this.$store.getters.modules.includes('2.13') ||
        this.$store.getters.modules.includes('2.25') ||
        this.$store.getters.modules.includes('2.14') ">
          <a href="#">
            Purchase
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/purchaseorder" v-if="this.$store.getters.modules.includes('2.11')">
                <a>Purchase Order</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchasechallan" v-if="this.$store.getters.modules.includes('2.12')">
                <a>Purchase Challan</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseinvoice" v-if="this.$store.getters.modules.includes('2.13')">
                <a>Purchase Invoice</a>
              </router-link>
            </li>
            <li>
              <router-link to="/dairyPurchaseInvoice" v-if="this.$store.getters.modules.includes('2.25')">
                <a>Dairy Purchase Invoice</a>
              </router-link>
            </li>
            <li>
              <router-link to="/finishedGoods" v-if="this.$store.getters.modules.includes('2.24')">
                <a>Finished Goods</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchasereturn" v-if="this.$store.getters.modules.includes('2.14')">
                <a>Purchase Return(Dr. Note)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseReturnBillWise" v-if="this.$store.getters.modules.includes('2.19')">
                <a>Purchase Return Billwise</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('2.15') ||this.$store.getters.modules.includes('2.16')
        || this.$store.getters.modules.includes('2.17')  ">
          <a href="#">
            Banking
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/cashwithdraw" v-if="this.$store.getters.modules.includes('2.15')">
                <a>Cash Withdraw</a>
              </router-link>
            </li>
            <li>
              <router-link to="/cashdeposit" v-if="this.$store.getters.modules.includes('2.16')">
                <a>Cash Deposit</a>
              </router-link>
            </li>
            <li>
              <router-link to="banktransfer" v-if="this.$store.getters.modules.includes('2.17')">
                <a>Bank Transfer</a>
              </router-link>
            </li>

            <li>
              <router-link to="/postDateCheque" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Post Date Cheque </a>
              </router-link>
            </li>

          </ul>
        </li>
      </ul>
    </li>

    <li class="treeview" v-if="this.$store.getters.modules.includes(',3.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-bar-chart-o" aria-hidden="true"></i>
        <span class="treeview-title">Accounting Report</span>
      </a>

      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('3.01') ||
        this.$store.getters.modules.includes('3.02') ||
        this.$store.getters.modules.includes('3.03') ||
        this.$store.getters.modules.includes('3.04') ||
        this.$store.getters.modules.includes('3.19') ">
          <a href="#">
            Account Book
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/cashBook" v-if="this.$store.getters.modules.includes('3.01')">
                <a href="#">Cash Book</a>
              </router-link>
            </li>

            <li>
              <router-link to="/dayBook" v-if="this.$store.getters.modules.includes('3.02')">
                <a href="#">Day Book</a>
              </router-link>
            </li>

            <li>
              <router-link to="/dayBookWithoutCash" v-if="this.$store.getters.modules.includes('3.19')">
                <a href="#">Day Book w/o cash</a>
              </router-link>
            </li>
            <li>
              <router-link to="/ledgerInquery" v-if="this.$store.getters.modules.includes('3.04')">
                <a href="#">General Ledger / Statement</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('3.01') ||
        this.$store.getters.modules.includes('3.02') ||
        this.$store.getters.modules.includes('3.03') ||
        this.$store.getters.modules.includes('3.04') ||
        this.$store.getters.modules.includes('3.19') ">
          <a href="#">
            Outstanding Report
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/customerReceivableReport" v-if="this.$store.getters.modules.includes('3.01')">
                <a href="#">Customer Receivable</a>
              </router-link>
            </li>
            <li>
              <router-link to="/supplierPayableReport" v-if="this.$store.getters.modules.includes('3.02')">
                <a href="#">Supplier Payable</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('3.01') ||
        this.$store.getters.modules.includes('3.02') ||
        this.$store.getters.modules.includes('3.03') ||
        this.$store.getters.modules.includes('3.04') ||
        this.$store.getters.modules.includes('3.19') ">
          <a href="#">
            Account Register
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/journalAll" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Transactions Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/journalVoidAll" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Transactions Void Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/journalPendingReport" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Transactions Pending Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/journalBook" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Journal Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/paymentBook" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Payment Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/receiptBook" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Receipt Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/reversalBook" v-if="this.$store.getters.modules.includes('3.21')">
                <a href="#">Reversal Register</a>
              </router-link>
            </li>

            <li>
              <router-link to="/debitNoteRegister" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Debit Note Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/creditNoteRegister" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Credit Note Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/cashDepositRegister" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Cash Deposit Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/cashWithdrawalRegister" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Cash Withdrawal Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/bankTransferRegister" v-if="this.$store.getters.modules.includes('3.03')">
                <a href="#">Bank Transfer Register</a>
              </router-link>
            </li>


          </ul>
        </li>
        <li class="treeview menu-open" v-if="
        this.$store.getters.modules.includes('3.22')||
        this.$store.getters.modules.includes('3.23')">
          <a href="#">
            Cost Center
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/costCenterLedger" v-if="this.$store.getters.modules.includes('3.22')">
                <a href="#">Cost Center Ledger</a>
              </router-link>
            </li>
            <li>
              <router-link to="/costCenterSummary" v-if="this.$store.getters.modules.includes('3.23')">
                <a href="#">Cost Center Summary</a>
              </router-link>
            </li>
          </ul>
        </li>
        <!-- Final Accounting Report Mneu Structure -->

        <!-- Party Report Menu Structure -->
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.11')
        || this.$store.getters.modules.includes('3.12')
        || this.$store.getters.modules.includes('3.13')">
          <a href="#">
            Party Book
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/partyStatement" v-if="this.$store.getters.modules.includes('3.11')">
                <a href="#">Party Ledger/Statement</a>
              </router-link>
            </li>
            <li>
              <router-link to="/customerTransactionSummary" v-if="this.$store.getters.modules.includes('3.13')">
                <a href="#">Customer Transaction Summary</a>
              </router-link>
            </li>
            <li>
              <router-link to="/supplierTransactionSummary" v-if="this.$store.getters.modules.includes('3.12')">
                <a href="#">Supplier Transaction Summary</a>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.18')">
          <a href="#">
            Banking Book
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/bankClosingBalExcludingOverDraft" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Bank Closing-Excluding overdraft</a>
              </router-link>
            </li>
            <li>
              <router-link to="/bankClosingBalIncludingOverDraft" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Bank Closing-Including overdraft</a>
              </router-link>
            </li>
            <li>
              <router-link to="/bankClosingBalOnlyOverDraft" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Bank Closing-Only overdraft</a>
              </router-link>
            </li>
            <li>
              <router-link to="/bankStatement" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Bank Ledger/Statement</a>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.18')">
          <a href="#">
            Bank Reconciliation
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/postDateChequeDetails" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Post Date Cheque Details </a>
              </router-link>
            </li>
            <li>
              <router-link to="/postDateChequeUnclear" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Uncleared Cheque Details</a>
              </router-link>
            </li>
            <li>
              <router-link to="/postDateChequeClear" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Cleared Cheque Details</a>
              </router-link>
            </li>
            <li>
              <router-link to="/reconciliationStatement" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Reconciliation Statement (TO DO)</a>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.18')">
          <a href="#">
            Trial Balance
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/trailBalanceOpening" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Trial Balance - Opening</a>
              </router-link>
            </li>
            <li>
              <router-link to="/trailBalance" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Trial Balance - Closing</a>
              </router-link>
            </li>
          </ul>
        </li>


        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.18')">
          <a href="#">
            Profit & Loss
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/profitAndLoss" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#"> Profit & Loss - Vertical</a>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.18')">
          <a href="#">
            Balance Sheet
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/balanceSheet" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Balance Sheet - Vertical</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('3.18')">
          <a href="#">
            Trading Report
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/tradingAccount" v-if="this.$store.getters.modules.includes('3.18')">
                <a href="#">Trading Report - Vertical</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>

    <li class="treeview" v-if="this.$store.getters.modules.includes(',4.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-bar-chart-o" aria-hidden="true"></i>
        <span class="treeview-title">Inventory Report</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.01') ||
        this.$store.getters.modules.includes('4.02') ||
        this.$store.getters.modules.includes('4.03') ||
        this.$store.getters.modules.includes('4.04') ||
        this.$store.getters.modules.includes('4.13') ||
        this.$store.getters.modules.includes('4.12') ||
        this.$store.getters.modules.includes('4.16') ||
        this.$store.getters.modules.includes('4.15') ||
        this.$store.getters.modules.includes('4.51') ||
        this.$store.getters.modules.includes('4.52') ||
        this.$store.getters.modules.includes('4.53') ||
        this.$store.getters.modules.includes('4.54')">
          <a href="#">
            Sales Register
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/salesOrderReport" v-if="this.$store.getters.modules.includes('4.01')">
                <a href="#">Sales Order Register</a>
              </router-link>
            </li>

            <li>
              <router-link to="/salesOrderCompletedReport" v-if="this.$store.getters.modules.includes('4.16')">
                <a href="#">Sales Order Completed Register</a>
              </router-link>
            </li>

            <li>
              <router-link to="/salesOrderPendingReport" v-if="this.$store.getters.modules.includes('4.15')">
                <a href="#">Sales Delivery Pending Register</a>
              </router-link>
            </li>

            <li>
              <router-link to="/salesChallanReport" v-if="this.$store.getters.modules.includes('4.02')">
                <a href="#">Sales Challan Register</a>
              </router-link>
            </li>

            <li>
              <router-link to="/salesInvoiceReport" v-if="this.$store.getters.modules.includes('4.03')">
                <a href="#">Sales Invoice Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoiceVoidReport" v-if="this.$store.getters.modules.includes('4.17')">
                <a href="#">Sales Invoice Void Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesReturnReport" v-if="this.$store.getters.modules.includes('4.04')">
                <a href="#">Sales Return Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoiceUnpaidReport" v-if="this.$store.getters.modules.includes('4.51')">
                <a href="#">Sales Unpaid Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoiceChequeReceived" v-if="this.$store.getters.modules.includes('4.54')">
                <a href="#">Sales Cheque Received </a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoicePaidReport" v-if="this.$store.getters.modules.includes('4.53')">
                <a href="#">Sales Invoice Paid Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoiceTodayUnpaidReport" v-if="this.$store.getters.modules.includes('4.48')">
                <a href="#">Payment Todays Follow (TO-DO)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesPaymentFollowUpTodaysReport" v-if="this.$store.getters.modules.includes('4.48')">
                <a href="#">Payment Todays FollowUp (DONE) </a>
              </router-link>
            </li>
            <li>
            <li>
              <router-link to="/salesUnpaidNextFollowUpReport" v-if="this.$store.getters.modules.includes('4.48')">
                <a href="#">Payment Next FollowUp Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoiceUnpaidAndPaidReport" v-if="this.$store.getters.modules.includes('4.47')">
                <a href="#">Sales Invoice Unpaid And Paid Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesInvoiceUnreceivedReport" v-if="this.$store.getters.modules.includes('4.52')">
                <a href="#">Sales Invoice Unreceived Register</a>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/salesInvoicePaidReport" v-if="this.$store.getters.modules.includes('4.52')">
                <a href="#">Sales Invoice Paid Report</a>
              </router-link>
            </li> -->
            <li>
              <router-link to="/salesInvoiceUnreceivedAllReport" v-if="this.$store.getters.modules.includes('4.45')">
                <a href="#">Sales Invoice Unreceived All Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/consumptionReport" v-if="this.$store.getters.modules.includes('4.18')">
                <a href="#">Consumption Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/damageReport" v-if="this.$store.getters.modules.includes('4.19')">
                <a href="#">Damage Report</a>
              </router-link>
            </li>
            <!-- <li>
             <router-link to="/salesReturnReport" v-if="this.$store.getters.modules.includes('4.04')">
               <a href="#">Sales Return Register</a>
             </router-link>
           </li> -->
            <li>
              <router-link to="/salesTaxRegister" v-if="this.$store.getters.modules.includes('4.12')">
                <a href="#">Sales Tax Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesSummaryReport" v-if="this.$store.getters.modules.includes('4.12')">
                <a href="#">Sales Summary Report</a>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/salesTaxRegister" v-if="this.$store.getters.modules.includes('4.12')">
                <a>Sales Tax Regsiter Report</a>
              </router-link>
            </li> -->
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.05') ||
        this.$store.getters.modules.includes('4.06') ||
        this.$store.getters.modules.includes('4.07') ||
        this.$store.getters.modules.includes('4.08') || this.$store.getters.modules.includes('4.13')   ">
          <a href="#">
            Purchase Register
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/purchaseOrderReport" v-if="this.$store.getters.modules.includes('4.05')">
                <a href="#">Purchase Order Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseChallanReport" v-if="this.$store.getters.modules.includes('4.06')">
                <a href="#">Purchase Challan Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseInvoiceReport" v-if="this.$store.getters.modules.includes('4.07')">
                <a href="#">Purchase Invoice Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/finishedGoods" v-if="this.$store.getters.modules.includes('4.21')">
                <a href="#">Finished Goods Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseReturnReport" v-if="this.$store.getters.modules.includes('4.08')">
                <a href="#">Purchase Return Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseTaxRegister" v-if="this.$store.getters.modules.includes('4.13')">
                <a href="#">Purchase Tax Register</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseSummaryReport" v-if="this.$store.getters.modules.includes('4.13')">
                <a href="#">purchase Summary Report</a>
              </router-link>
            </li>
          </ul>
        </li>

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.14') || this.$store.getters.modules.includes('4.39')">
          <a href="#">
            Stock Transfer Report
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/stockTransforReportInternal" v-if="this.$store.getters.modules.includes('4.14')">
                <a>Transfer Report (Internal)</a>
              </router-link>
            </li>

            <li>
              <router-link to="/stockTransforReportWarehouseWise" v-if="this.$store.getters.modules.includes('4.14')">
                <a>Transfer Report Store Wise</a>
              </router-link>
            </li>

            <li>
              <router-link to="/stockTransforReportInternalUser" v-if="this.$store.getters.modules.includes('4.39')">
                <a>Transfer Report (Internal) User</a>
              </router-link>
            </li>

          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.08') ||
        this.$store.getters.modules.includes('4.11') ||
        this.$store.getters.modules.includes('4.09') ||
        this.$store.getters.modules.includes('4.22') ||
        this.$store.getters.modules.includes('4.23') ||
        this.$store.getters.modules.includes('4.24') ||
        this.$store.getters.modules.includes('4.25') ||
        this.$store.getters.modules.includes('4.26') ||
        this.$store.getters.modules.includes('4.41')" >
          <a href="#">
            Stock Book
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/itemDayBook" v-if="this.$store.getters.modules.includes('4.09')">
                <a href="#">Item Day Book</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemStatement" v-if="this.$store.getters.modules.includes('4.11')">
                <a href="#">General Item Ledger/Statement</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemPurchaseDetailReport" v-if="this.$store.getters.modules.includes('4.42')">
                <a href="#">Item Purchase History Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemSalesDetailReport" v-if="this.$store.getters.modules.includes('4.43')">
                <a href="#">Item Sales History Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/inventoryInOutReport" v-if="this.$store.getters.modules.includes('4.09')">
                <a href="#">Inventory In/Out Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemInOutStoreWise" v-if="this.$store.getters.modules.includes('4.11')">
                <a href="#">Inventory In/Out - Store Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/closingStock" v-if="this.$store.getters.modules.includes('4.11')">
                <a href="#">Closing Stock</a>
              </router-link>
            </li>
            <li>
              <router-link to="/negativeStockReport" v-if="this.$store.getters.modules.includes('4.11')">
                <a href="#">Negative Stock Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/storeWiseClosingStock" v-if="this.$store.getters.modules.includes('4.24')">
                <a href="#">Closing Stock (Counter Wise)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/storeWiseClosingStockUser" v-if="this.$store.getters.modules.includes('4.41')">
                <a href="#">Closing Stock (Counter Wise) User</a>
              </router-link>
            </li>
            <li>
              <router-link to="/storeAndItemWiseClosingStock" v-if="this.$store.getters.modules.includes('4.23')">
                <a href="#">Closing Stock (Store Wise)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemMasterListForRates" v-if="this.$store.getters.modules.includes('4.22')">
                <a href="#">Update Sales & Purchase Rate</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.25')
        || this.$store.getters.modules.includes('4.26')">
          <a href="#">
            Purchase Analysis Report
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/purchaseAnalysisProductWise" v-if="this.$store.getters.modules.includes('4.25')">
                <a href="#">Purchase Product Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseAnalysisSupplierWise" v-if="this.$store.getters.modules.includes('4.26')">
                <a href="#">Purchase Supplier Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseAnalysisMonthlyProductWise" v-if="this.$store.getters.modules.includes('4.29')">
                <a href="#">Purchase Product Monthly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseAnalysisMonthlySupplierWise"
                           v-if="this.$store.getters.modules.includes('4.31')">
                <a href="#">Purchase Supplier Monthly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseAnalysisQuarterlyProductWise"
                           v-if="this.$store.getters.modules.includes('4.34')">
                <a href="#">Purchase Product Quarterly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/purchaseAnalysisQuarterlySupplierWise"
                           v-if="this.$store.getters.modules.includes('4.35')">
                <a href="#">Purchase Supplier Quarterly Wise</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.27')
        || this.$store.getters.modules.includes('4.28')">
          <a href="#">
            Sales Analysis Report
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/salesAnalysisProductWise" v-if="this.$store.getters.modules.includes('4.27')">
                <a href="#">Sales Product Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesAnalysisCustomerWise" v-if="this.$store.getters.modules.includes('4.28')">
                <a href="#">Sales Customer Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesAnalysisMonthlyProductWise" v-if="this.$store.getters.modules.includes('4.32')">
                <a href="#">Sales Product Monthly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesAnalysisMonthlyCustomerWise" v-if="this.$store.getters.modules.includes('4.33')">
                <a href="#">Sales Customer Monthly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesAnalysisMonthlyCustomerFiscalYearWise" v-if="this.$store.getters.modules.includes('4.33')">
                <a href="#">Sales Fiscal Year Customer Monthly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesAnalysisQuarterlyProductWise" v-if="this.$store.getters.modules.includes('4.36')">
                <a href="#">Sales Product Quarterly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesAnalysisQuarterlyCustomerWise" v-if="this.$store.getters.modules.includes('4.37')">
                <a href="#">Sales Customer Quarterly Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/customerWiseSalesCount" v-if="this.$store.getters.modules.includes('4.46')">
                <a href="#">Customer Wise Sales Count</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('4.38')">
          <a href="#">
            Profit And Loss Analysis Report
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/profitAndLossAnalysisProductWise" v-if="this.$store.getters.modules.includes('4.38')">
                <a href="#">Profit And Loss Analysis Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/profitAndLossAnalysis" v-if="this.$store.getters.modules.includes('4.38')">
                <a href="#">Profit/Loss Analysis Item Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/profitReportGross" v-if="this.$store.getters.modules.includes('4.44')">
                <a href="#">Profit Report Gross</a>
              </router-link>
            </li>
            <li>
              <router-link to="/expensesReport" v-if="this.$store.getters.modules.includes('4.49')">
                <a href="#">Expenses Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesPaidCollectionReport" v-if="this.$store.getters.modules.includes('4.55')">
                <a href="#">Sales Paid Collection Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/monthlyDueAnalysisReport" v-if="this.$store.getters.modules.includes('4.56')">
                <a href="#">Monthly Due Analysis Report</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="this.$store.getters.modules.includes(',15.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-pie-chart" aria-hidden="true"></i>
        <span class="treeview-title">Graph View</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('15.01')">
          <a href="#">
            Graphs
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/purchaseSalesGraph" v-if="this.$store.getters.modules.includes('15.01')">
                <a href="#">Purchase Sales</a>
              </router-link>
            </li>

            <li>
              <router-link to="/receiptPaymentGraph" v-if="this.$store.getters.modules.includes('15.02')">
                <a href="#">Receipt Payment</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesTragetGraph" v-if="this.$store.getters.modules.includes('15.03')">
                <a href="#">Monthly Sales Target</a>
              </router-link>
            </li>

            <li>
              <router-link to="/itemSalesMonthlyGraph" v-if="this.$store.getters.modules.includes('15.04')">
                <a href="#">Item Wise Monthly Graph Wise</a>
              </router-link>
            </li>

            <li>
              <router-link to="/WeeklySalesReportGraph" v-if="this.$store.getters.modules.includes('15.05')">
                <a href="#">Weekly Sales Report Graph</a>
              </router-link>
            </li>

            <li>
              <router-link to="/ItemWiseProfitLossAnalysisGraph" v-if="this.$store.getters.modules.includes('15.06')">
                <a href="#">Item Wise Profit Loss Analysis Graph</a>
              </router-link>
            </li>

            <li>
              <router-link to="/DailySalesReportGraph" v-if="this.$store.getters.modules.includes('15.07')">
                <a href="#">Daily Sales Report Graph</a>
              </router-link>
            </li>

            <li>
              <router-link to="/CustomerWiseSalesCountGraph" v-if="this.$store.getters.modules.includes('15.08')">
                <a href="#">Customer Wise Sales Count Graph</a>
              </router-link>
            </li>
            <li>
              <router-link to="/UserWiseSalesGraph" v-if="this.$store.getters.modules.includes('15.09')">
                <a href="#">User Wise Sales Graph</a>
              </router-link>
            </li>
            <li>
              <router-link to="/GrossMarginGraph" v-if="this.$store.getters.modules.includes('15.11')">
                <a href="#">Gross Margin Graph</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salesPaidCashCollectionGraph" v-if="this.$store.getters.modules.includes('15.12')">
                <a href="#">Monthly Sales Payment Collection Graph</a>
              </router-link>
            </li>
            <li>
              <router-link to="/DueAnalysisGraph" v-if="this.$store.getters.modules.includes('15.13')">
                <a href="#">Monthly Due Analysis Graph</a>
              </router-link>
            </li>

          </ul>
        </li>

 
      </ul>
    </li>
    

    <li class="treeview" v-if="this.$store.getters.modules.includes(',6.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-truck" aria-hidden="true"></i>
        <span class="treeview-title">Delivery</span>
      </a>
      <ul class="treeview-menu">
        <li>
          <router-link to="/deliveryEntryForm" v-if="this.$store.getters.modules.includes('6.01')">
            <a href="#">Delivery Entry From</a>
          </router-link>
        </li>

        <li>
          <router-link to="/toBeVerifyDelivery" v-if="this.$store.getters.modules.includes('6.15')">
            <a href="#">To Be Verify Delivery</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryReport" v-if="this.$store.getters.modules.includes('6.02')">
            <a href="#">Delivery Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryUserTrack" v-if="this.$store.getters.modules.includes('6.03')">
            <a href="#">Delivery User Track</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveredReport" v-if="this.$store.getters.modules.includes('6.04')">
            <a href="#">Completed Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/vendorDeliveryReport" v-if="this.$store.getters.modules.includes('6.05')">
            <a href="#">Vendor Delivery Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryRequestReport" v-if="this.$store.getters.modules.includes('6.06')">
            <a href="#">Request Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryPendingReport" v-if="this.$store.getters.modules.includes('6.09')">
            <a href="#">Pending Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryCancelledReport" v-if="this.$store.getters.modules.includes('6.13')">
            <a href="#">Cancel Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/vendorPaidReport" v-if="this.$store.getters.modules.includes('6.07')">
            <a href="#">Vendor Paid Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/vendorUnPaidReport" v-if="this.$store.getters.modules.includes('6.08')">
            <a href="#">Vendor Unpaid Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryReturnedReport" v-if="this.$store.getters.modules.includes('6.14')">
            <a href="#">Return To Vendor Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/deliveryRemarksLogReport" v-if="this.$store.getters.modules.includes('6.12')">
            <a href="#">Remarks Log Report</a>
          </router-link>
        </li>
      </ul>
    </li>

      <li class="treeview" v-if="this.$store.getters.modules.includes(',13.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-truck" aria-hidden="true"></i>
        <span class="treeview-title">Ecommerce</span>
      </a>
      <ul class="treeview-menu">
        <li>
          <router-link to="/ecommercePending" v-if="this.$store.getters.modules.includes('13.04')">
            <a href="#">Pending Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/ecommerceOrder" v-if="this.$store.getters.modules.includes('13.01')">
            <a href="#">Processing Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/ecommerceCancelled" v-if="this.$store.getters.modules.includes('13.02')">
            <a href="#">Cancelled Report</a>
          </router-link>
        </li>
        <li>
          <router-link to="/ecommerceCompleted" v-if="this.$store.getters.modules.includes('13.03')">
            <a href="#">Completed Report</a>
          </router-link>
        </li>

        <li>
          <router-link to="/ecommerceHold" v-if="this.$store.getters.modules.includes('13.05')">
            <a href="#">Hold Report</a>
          </router-link>
        </li>
         <li>
          <router-link to="/ecommerceInquiry" v-if="this.$store.getters.modules.includes('13.06')">
            <a href="#">Inquiry</a>
          </router-link>
        </li>
      </ul>
    </li>


    <li class="treeview" v-if="this.$store.getters.modules.includes(',9.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-truck" aria-hidden="true"></i>
        <span class="treeview-title">Fixed Assets</span>
      </a>

      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('9.15') ||
        this.$store.getters.modules.includes('9.16') || this.$store.getters.modules.includes('9.17')
        || this.$store.getters.modules.includes('9.18')">
          <a href="#">
            Master
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/categorySetup" v-if="this.$store.getters.modules.includes('9.01')">
                <a>Item Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/subCategorySetup" v-if="this.$store.getters.modules.includes('9.02')">
                <a>Item Sub Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/faItemMaster" v-if="this.$store.getters.modules.includes('9.03')">
                <a>Item Master</a>
              </router-link>
            </li>

            <li>
              <router-link to="/poolConfiguration" v-if="this.$store.getters.modules.includes('9.04')">
                <a>Pool Setup </a>
              </router-link>
            </li>
            <li>
              <router-link to="/faExtraExpenses" v-if="this.$store.getters.modules.includes('9.05')">
                <a>Bill Sundary </a>
              </router-link>
            </li>
            <li>
              <router-link to="/faExtraExpensesItemwise" v-if="this.$store.getters.modules.includes('9.06')">
                <a>Bill Sundary Item Wise </a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('9.15') ||
        this.$store.getters.modules.includes('9.16') || this.$store.getters.modules.includes('9.17')
        || this.$store.getters.modules.includes('9.18')">
          <a href="#">
            Purchase
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/fixedAssetsPurchaseOrder" v-if="this.$store.getters.modules.includes('9.15')">
                <a>Purchase Order</a>
              </router-link>
            </li>
            <li>
              <router-link to="/fixedAssetsPurchaseChallan" v-if="this.$store.getters.modules.includes('9.16')">
                <a>Purchase Challan</a>
              </router-link>
            </li>
            <li>
              <router-link to="/fixedAssetsPurchaseInvoice" v-if="this.$store.getters.modules.includes('9.17')">
                <a>Purchase Invoice</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('9.11') ||
        this.$store.getters.modules.includes('9.12') || this.$store.getters.modules.includes('9.13')
        || this.$store.getters.modules.includes('9.14') ">
          <a href="#">
            Sales
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/fixedAssetsSalesOrder" v-if="this.$store.getters.modules.includes('9.11')">
                <a>Sales Order</a>
              </router-link>
            </li>
            <li>
              <router-link to="/fixedAssetsSalesChallan" v-if="this.$store.getters.modules.includes('9.12')">
                <a>Sales Challan</a>
              </router-link>
            </li>
            <li>
              <router-link to="/fixedAssetsSalesInvoice" v-if="this.$store.getters.modules.includes('9.13')">
                <a>Sales Invoice</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>
    <li class="treeview" v-if="this.$store.getters.modules.includes(',7.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-cart-plus" aria-hidden="true"></i>
        <span class="treeview-title">POS</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('7.01') ||
        this.$store.getters.modules.includes('7.02') || this.$store.getters.modules.includes('7.03')
        || this.$store.getters.modules.includes('7.04')
        || this.$store.getters.modules.includes('7.05')
        || this.$store.getters.modules.includes('7.06')
        || this.$store.getters.modules.includes('7.07')
        || this.$store.getters.modules.includes('7.08')">
          <a href="#">
            POS
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/posEntry" v-if="this.$store.getters.modules.includes('7.01')">
                <a href="#">Entry</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posSalesReport" v-if="this.$store.getters.modules.includes('7.02')">
                <a href="#">Settle Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/unSettlePosSalesReport" v-if="this.$store.getters.modules.includes('7.03')">
                <a href="#">Unsettle Sales</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posUnpaidReport" v-if="this.$store.getters.modules.includes('7.13')">
                <a href="#">Unpaid Sales</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posAllUnPaidReport" v-if="this.$store.getters.modules.includes('7.14')">
                <a href="#">All Unpaid Sales</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posDublicateSalesReport" v-if="this.$store.getters.modules.includes('7.15')">
                <a href="#">Dublicate Sales Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posSalesDeleteReport" v-if="this.$store.getters.modules.includes('7.15')">
                <a href="#">Sales Deleted Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posDailySalesReport" v-if="this.$store.getters.modules.includes('7.05')">
                <a href="#">Daily Sales Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posCustomerSalesReport" v-if="this.$store.getters.modules.includes('7.02')">
                <a href="#">Pos Customer Sales Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/posSalesReturnBillwise" v-if="this.$store.getters.modules.includes('7.06')">
                <a href="#">Pos Sales Return Billwise</a>
              </router-link>
            </li>
            <li v-if="this.$store.getters.modules.includes('7.07')">
              <router-link to="/posItemWiseStockMgmt">
                <a href="#">Stock Adjustment</a>
              </router-link>
            </li>
            <li v-if="this.$store.getters.modules.includes('7.08')">
              <router-link to="/posClosingStock">
                <a href="#">Item Closing Stock</a>
              </router-link>
            </li>
            <li v-if="this.$store.getters.modules.includes('7.09')">
              <router-link to="/stockInHistoryReport">
                <a href="#">Stock In History Report</a>
              </router-link>
            </li>
            <li v-if="this.$store.getters.modules.includes('7.04')">
              <router-link to="/counterSetup">
                <a href="#">Counter Setup</a>
              </router-link>
            </li>
            <li v-if="this.$store.getters.modules.includes('7.17')">
              <router-link to="/rewardPoint">
                <a href="#">Reward Point</a>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/nocPosSales" v-if="this.$store.getters.modules.includes('7.01')">
                <a href="#">Noc Pos Sales</a>
              </router-link>
            </li> -->
          </ul>

        </li>

      </ul>
    </li>
    <li class="treeview" v-if="this.$store.getters.modules.includes(',9.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-cart-plus" aria-hidden="true"></i>
        <span class="treeview-title">Fixed Assets</span>
        <span class="pull-right-container pull-right">
          <i class="fa fa-angle-left fa-fw"></i>
        </span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('9.01') ||
        this.$store.getters.modules.includes('9.02') || this.$store.getters.modules.includes('9.03')
        || this.$store.getters.modules.includes('9.04')
        || this.$store.getters.modules.includes('9.05')
        || this.$store.getters.modules.includes('9.06')
        || this.$store.getters.modules.includes('9.07')">
          <a href="#">
            Fixed Assets Master
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/categorySetup" v-if="this.$store.getters.modules.includes('9.01')">
                <a href="#">Category</a>
              </router-link>
            </li>
            <li>
              <router-link to="/subCategorySetup" v-if="this.$store.getters.modules.includes('9.02')">
                <a href="#">Sub-Category</a>
              </router-link>
            </li>
            <li>
              <router-link to="/faItemMaster" v-if="this.$store.getters.modules.includes('9.03')">
                <a href="#">FA Item Master</a>
              </router-link>
            </li>
            <li>
              <router-link to="/faExtraExpenses" v-if="this.$store.getters.modules.includes('9.04')">
                <a href="#">FA Extra Expenses</a>
              </router-link>
            </li>
            <li>
              <router-link to="/faExtraExpensesItemwise" v-if="this.$store.getters.modules.includes('9.05')">
                <a href="#">FA Extra Expenses Item Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/poolConfiguration" v-if="this.$store.getters.modules.includes('9.06')">
                <a href="#">Pool Configuration</a>
              </router-link>
            </li>
          </ul>

        </li>

      </ul>
    </li>
    <!-- <li class="treeview menu-open"
        v-if="this.$store.getters.modules.includes(',8.')">
      <a href="#">
        <i class="fa fa-users" aria-hidden="true"></i>
        <span class="treeview-title">Production</span>
        <span class="pull-right-container">
           <i class="fa fa-angle-left pull-right"/>
         </span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.01') ||
         this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03')">
          <a href="#">
            Master
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a> -->

    <!-- <ul class="treeview-menu">
      <li>
        <router-link to="/manufacturer" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Manufacturer</a>
        </router-link>
      </li>
      <li>
        <router-link to="/manufacturingOverhead" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Manufacturing Overhead</a>
        </router-link>
      </li>
      <li>
        <router-link to="/manufacturingProductionReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Manufacture Production Report</a>
        </router-link>
      </li>
    </ul>
  </li>
  <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.01') ||
   this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03')">
    <a href="#">
      Bill of Material
      <span class="pull-right-container">
         <i class="fa fa-angle-left pull-right"/>
       </span>
    </a>

    <ul class="treeview-menu">
      <li>
        <router-link to="/batchProcessSetup" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Batch Process Setup</a>
        </router-link>
      </li>
      <li>
        <router-link to="/batchProcessFormulaSetup" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Batch Process Formula Setup</a>
        </router-link>
      </li>
      <li>
        <router-link to="/batchSetup" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Batch Setup</a>
        </router-link>
      </li>
    </ul>
  </li>
  <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.01') ||
   this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03')">
    <a href="#">
      Entry
      <span class="pull-right-container">
         <i class="fa fa-angle-left pull-right"/>
       </span>
    </a>

    <ul class="treeview-menu">
      <li>
        <router-link to="/processIssuedRaw" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Process Issued Raw</a>
        </router-link>
      </li>
      <li>
        <router-link to="/executeBatch" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Execute Batch</a>
        </router-link>
      </li>
      <li>
        <router-link to="/stockJournalEntry" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Stock Journal Entry</a>
        </router-link>
      </li>
    </ul>
  </li>
  <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.01') ||
   this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03')">
    <a href="#">
      Report
      <span class="pull-right-container">
         <i class="fa fa-angle-left pull-right"/>
       </span>
    </a>

    <ul class="treeview-menu">
      <li>
        <router-link to="/dailyPurchaseReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Daily Purchase Register</a>
        </router-link>
      </li>
      <li>
        <router-link to="/blendReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Blend Report</a>
        </router-link>
      </li>
      <li>
        <router-link to="/packingReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Packing Report</a>
        </router-link>
      </li>
      <li>
        <router-link to="/compileReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Compile Report</a>
        </router-link>
      </li>
      <li>
        <router-link to="/stockJournalReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Stock Journal Report</a>
        </router-link>
      </li>
    </ul>
  </li>
  <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.01') ||
   this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03')">
    <a href="#">
      Manufacturing Inventory
      <span class="pull-right-container">
         <i class="fa fa-angle-left pull-right"/>
       </span>
    </a>

    <ul class="treeview-menu">
      <li>
        <router-link to="/itemIssueReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Item Issue/Blending Report</a>
        </router-link>
      </li>
      <li>
        <router-link to="/batchExecutedReport" v-if="this.$store.getters.modules.includes('8.01')">
          <a href="#">Batch Executed Report</a>
        </router-link>
      </li>
    </ul>
  </li>
</ul>
</li> -->
    <!-- Human Resource Menu structure -->
    <li class="treeview menu-open"
        v-if="this.$store.getters.modules.includes(',8.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-users" aria-hidden="true"></i>
        <span class="treeview-title">Human Resource</span>
      </a>
      <ul class="treeview-menu">
        <li>
          <router-link to="/profile" v-if="this.$store.getters.modules.includes('8.33')">
            <a href="#">Profile</a>
          </router-link>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.01') ||
         this.$store.getters.modules.includes('8.02') || this.$store.getters.modules.includes('8.03') ||
         this.$store.getters.modules.includes('8.04') ||
         this.$store.getters.modules.includes('8.05') ||
         this.$store.getters.modules.includes('8.06')">
          <a href="#">
            Job
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>
          <ul class="treeview-menu">
            <li>
              <router-link to="/jobTitle" v-if="this.$store.getters.modules.includes('8.01')">
                <a href="#">Job Title</a>
              </router-link>
            </li>
            <li>
              <router-link to="/employmentStatus" v-if="this.$store.getters.modules.includes('8.02')">
                <a href="#">Employment Status</a>
              </router-link>
            </li>
            <li>
              <router-link to="/jobCategory" v-if="this.$store.getters.modules.includes('8.03')">
                <a href="#">Job Category</a>
              </router-link>
            </li>
            <li>
              <router-link to="/workShift" v-if="this.$store.getters.modules.includes('8.04')">
                <a href="#">Work Shift</a>
              </router-link>
            </li>
            <li>
              <router-link to="/shiftManagement" v-if="this.$store.getters.modules.includes('8.05')">
                <a href="#">Shift Management</a>
              </router-link>
            </li>
            <li>
              <router-link to="/terminationReason" v-if="this.$store.getters.modules.includes('8.06')">
                <a href="#">Termination Reason</a>
              </router-link>
            </li>
          </ul>

        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.07') ||
          this.$store.getters.modules.includes('8.08') || this.$store.getters.modules.includes('8.09') ||
          this.$store.getters.modules.includes('8.11') ||
          this.$store.getters.modules.includes('8.12') ||
          this.$store.getters.modules.includes('8.13')">
          <a href="#">
            Qualification
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/skills" v-if="this.$store.getters.modules.includes('8.07')">
                <a href="#">Skills</a>
              </router-link>
            </li>
            <li>
              <router-link to="/education" v-if="this.$store.getters.modules.includes('8.08')">
                <a href="#">Education</a>
              </router-link>
            </li>
            <li>
              <router-link to="/language" v-if="this.$store.getters.modules.includes('8.09')">
                <a href="#">Language</a>
              </router-link>
            </li>
            <li>
              <router-link to="/license" v-if="this.$store.getters.modules.includes('8.11')">
                <a href="#">License</a>
              </router-link>
            </li>
            <li>
              <router-link to="/membership" v-if="this.$store.getters.modules.includes('8.12')">
                <a href="#">Membership</a>
              </router-link>
            </li>
            <li>
              <router-link to="/nationality" v-if="this.$store.getters.modules.includes('8.13')">
                <a href="#">Nationality</a>
              </router-link>
            </li>
          </ul>

        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.14') ||
          this.$store.getters.modules.includes('8.15') || this.$store.getters.modules.includes('8.16') ||
          this.$store.getters.modules.includes('8.17') ||
          this.$store.getters.modules.includes('8.18') ">
          <a href="#">
            Leave
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/leaveType" v-if="this.$store.getters.modules.includes('8.14')">
                <a href="#">Leave type</a>
              </router-link>
            </li>
            <li>
              <router-link to="/leavePeriod" v-if="this.$store.getters.modules.includes('8.15')">
                <a href="#">Leave Period</a>
              </router-link>
            </li>
            <li>
              <router-link to="/workingWeek" v-if="this.$store.getters.modules.includes('8.16')">
                <a href="#">Working week</a>
              </router-link>
            </li>
            <li>
              <router-link to="/holidays" v-if="this.$store.getters.modules.includes('8.17')">
                <a href="#">Holidays</a>
              </router-link>
            </li>
            <li>
              <router-link to="/leaveEntitlement" v-if="this.$store.getters.modules.includes('8.18')">
                <a href="#">Entitlement</a>
              </router-link>
            </li>
            <!--             <li>-->
            <!--               <router-link to="/nationality" v-if="this.$store.getters.modules.includes('5.02')">-->
            <!--                 <a href="#">Nationality</a>-->
            <!--               </router-link>-->
            <!--             </li>-->
          </ul>

        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.19') ||
          this.$store.getters.modules.includes('8.21')">
          <a href="#">
            Pay
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/payHead" v-if="this.$store.getters.modules.includes('8.19')">
                <a href="#">Pay Head</a>
              </router-link>
            </li>
            <li>
              <router-link to="/payGrade" v-if="this.$store.getters.modules.includes('8.21')">
                <a href="#">Pay Grade</a>
              </router-link>
            </li>
          </ul>

        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.22')">
          <a href="#">
            Employee
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/employeeGroup" v-if="this.$store.getters.modules.includes('8.22')">
                <a href="#">Employee Group</a>
              </router-link>
            </li>
            <li>
              <router-link to="/employeePosition" v-if="this.$store.getters.modules.includes('8.22')">
                <a href="#">Employee SubGroup</a>
              </router-link>
            </li>
             <li>
              <router-link to="/employeeSubGroup1" v-if="this.$store.getters.modules.includes('8.22')">
                <a href="#">Employee SubGroup Child</a>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/employee" v-if="this.$store.getters.modules.includes('8.23')">
                <a href="#">Create Employee</a>
              </router-link>
            </li> -->
            <li>
              <router-link to="/addEmployee" v-if="this.$store.getters.modules.includes('8.22')">
                <a href="#">Manage Employee</a>
              </router-link>
            </li>
            <li>
              <router-link to="employeeTransfer" v-if="this.$store.getters.modules.includes('8.23')">
                <a href="#">Employee Transfer</a>
              </router-link>
            </li>
          </ul>

        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.24') ||
         this.$store.getters.modules.includes('8.25')">
          <a href="#">
            Leave and Fieldwork
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/leaveRequest" v-if="this.$store.getters.modules.includes('8.24')">
                <a href="#">Request</a>
              </router-link>
            </li>
            <li>
              <router-link to="/leaveReports" v-if="this.$store.getters.modules.includes('8.25')">
                <a href="#">Reports</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.26') ||
         this.$store.getters.modules.includes('8.27')">
          <a href="#">
            Attendance
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/attendanceRequest" v-if="this.$store.getters.modules.includes('8.26')">
                <a href="#">Attendance Request</a>
              </router-link>
            </li>
            <li>
              <router-link to="/attendanceRequestReport" v-if="this.$store.getters.modules.includes('8.26')">
                <a href="#">Attendance Request Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/leaveReports" v-if="this.$store.getters.modules.includes('8.27')">
                <a href="#">Late and Early Request</a>
              </router-link>
            </li>
          </ul>

        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.28') ||
         this.$store.getters.modules.includes('8.29')">
          <a href="#">
            Pay Roll
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/salaryEntry" v-if="this.$store.getters.modules.includes('8.28')">
                <a href="#">Salary Entry</a>
              </router-link>
            </li>
            <li>
              <router-link to="/salaryReport" v-if="this.$store.getters.modules.includes('8.29')">
                <a href="#">Salary Report</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('8.31') ||
         this.$store.getters.modules.includes('8.32')">
          <a href="#">
            Inventory Assign
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/inventoryAssignEntry" v-if="this.$store.getters.modules.includes('8.31')">
                <a href="#">Inventory Assign Entry</a>
              </router-link>
            </li>
            <li>
              <router-link to="/inventoryAssignReport" v-if="this.$store.getters.modules.includes('8.32')">
                <a href="#">Inventory Assign Report</a>
              </router-link>
            </li>

          </ul>

        </li>
        <!-- <li>
          <a href="#">Item Group Report</a>
        </li> -->

      </ul>
    </li>


    <li class="treeview menu-open"
        v-if="this.$store.getters.modules.includes(',12.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
        <span class="treeview-title">Crm</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('12.01') ||
         this.$store.getters.modules.includes('12.02') || this.$store.getters.modules.includes('12.03')
         || this.$store.getters.modules.includes('12.04') || this.$store.getters.modules.includes('12.11')">
          <a href="#">
            Master
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/crmClientDetails" v-if="this.$store.getters.modules.includes('12.01')">
                <a href="#">Client Details</a>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/manufacturingOverhead" v-if="this.$store.getters.modules.includes('8.01')">
                <a href="#">Client PersonalInfo</a>
              </router-link>
            </li> -->
            <li>
              <router-link to="/crmCompanies" v-if="this.$store.getters.modules.includes('12.02')">
                <a href="#">Companies</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmCustomer" v-if="this.$store.getters.modules.includes('12.03')">
                <a href="#">Customer</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmProductDetails" v-if="this.$store.getters.modules.includes('12.04')">
                <a href="#">Product Details</a>
              </router-link>
            </li>
        
            <li>
              <router-link to="/crmMasterSetup" v-if="this.$store.getters.modules.includes('12.12')">
                <a href="#">Master Setup</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('12.06') ||
         this.$store.getters.modules.includes('12.07') || this.$store.getters.modules.includes('12.08')
         || this.$store.getters.modules.includes('12.04') || this.$store.getters.modules.includes('12.11') || this.$store.getters.modules.includes('12.24')">
          <a href="#">
            Entry
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/crmVIsitorDetails" v-if="this.$store.getters.modules.includes('12.08')">
                <a href="#">Visitors</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmDealDetails" v-if="this.$store.getters.modules.includes('12.04')">
                <a href="#">Deal Details</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmTaskDetails" v-if="this.$store.getters.modules.includes('12.06')">
                <a href="#">Task</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmTicketDetails" v-if="this.$store.getters.modules.includes('12.07')">
                <a href="#">Ticket Details</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmFollowUpDetails" v-if="this.$store.getters.modules.includes('12.11')">
                <a href="#">Follow Up</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmAllFollowUpDetails" v-if="this.$store.getters.modules.includes('12.24')">
                <a href="#">Follow Up All List</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('12.11') ||
         this.$store.getters.modules.includes('12.12') || this.$store.getters.modules.includes('12.13') || 
         this.$store.getters.modules.includes('12.14')">
          <a href="#">
            Report
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/crmCustomerWiseReport" v-if="this.$store.getters.modules.includes('12.13')">
                <a href="#">Customer Wise Next Follow Up</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmTodayFollowUp" v-if="this.$store.getters.modules.includes('12.14')">
                <a href="#">Todays FollowUp (To Do)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmTotalTodayFollowUp" v-if="this.$store.getters.modules.includes('12.15')">
                <a href="#">Total Todays FollowUp (Done)</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmNotReceivedCalls" v-if="this.$store.getters.modules.includes('12.16')">
                <a href="#">Call Not Received</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmFollowUpDateRange" v-if="this.$store.getters.modules.includes('12.19')">
                <a href="#">Follow Up Between Date</a>
              </router-link>
            </li>
            <li>
              <router-link to="/quotationSent" v-if="this.$store.getters.modules.includes('12.17')">
                <a href="#">Quotation Sent</a>
              </router-link>
            </li>
            <li>
              <router-link to="/sampleSent" v-if="this.$store.getters.modules.includes('12.18')">
                <a href="#">Sample Sent</a>
              </router-link>
            </li>
          </ul>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('12.21') ||
         this.$store.getters.modules.includes('12.22') || this.$store.getters.modules.includes('12.23')">
          <a href="#">
            Graph
            <span class="pull-right-container">
               <i class="fa fa-angle-left pull-right"/>
             </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/crmStageWiseGraph" v-if="this.$store.getters.modules.includes('12.21')">
                <a href="#">CRM Stage Wise Graph</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmUserWiseGraph" v-if="this.$store.getters.modules.includes('12.22')">
                <a href="#">CRM User Wise Graph</a>
              </router-link>
            </li>
            <li>
              <router-link to="/crmUserWiseMonthlyGraph" v-if="this.$store.getters.modules.includes('12.23')">
                <a href="#">CRM User Wise Monthly Graph</a>
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </li>

    <li class="treeview" v-if="this.$store.getters.modules.includes(',5.')">
      <a href="#" class="treeview-link">
        <i class="fa fa-cogs" aria-hidden="true"></i>
        <span class="treeview-title">Setting</span>
      </a>
      <ul class="treeview-menu">
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('5.01') ||
        this.$store.getters.modules.includes('5.02') || this.$store.getters.modules.includes('5.05') ">
          <a href="#">
            User/Role
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/user" v-if="this.$store.getters.modules.includes('5.01')">
                <a href="#">User</a>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/printPage" v-if="this.$store.getters.modules.includes('5.05')">
                <a href="#">Pos Print Page</a>
              </router-link>
            </li>
            <li>
              <router-link to="/arbPrint" v-if="this.$store.getters.modules.includes('5.05')">
                <a href="#">Arb Print Page</a>
              </router-link>
            </li> -->

            <li>
              <router-link to="/role" v-if="this.$store.getters.modules.includes('5.02')">
                <a href="#">Role</a>
              </router-link>
            </li>
             <li>
              <router-link to="/branchCompany" v-if="this.$store.getters.modules.includes('5.37')">
                <a href="#">Branch Company</a>
              </router-link>
            </li>
          </ul>

        </li>
        <li>
          <router-link to="/basicAccountSetup" v-if="this.$store.getters.modules.includes('5.14')">
            <a href="#">Basic Account Setup</a>
          </router-link>
        </li>
        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('5.03') ">
          <a href="#">
            Transaction
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/fiscalYear" v-if="this.$store.getters.modules.includes('5.03')">
                <a href="#">Fiscal Year</a>
              </router-link>
            </li>
            <li>
              <router-link to="/fiscalYearSettlement" v-if="this.$store.getters.modules.includes('5.18')">
                <a href="#">Fiscal Year Settlement</a>
              </router-link>
            </li>
            <li>
              <router-link to="/balanceBroughtDown" v-if="this.$store.getters.modules.includes('5.19')">
                <a href="#">Fiscal Year Broughtdown</a>
              </router-link>
            </li>
            <li>
              <router-link to="/itemBroughtDownStoreWise" v-if="this.$store.getters.modules.includes('5.19')">
                <a href="#">Item Balance Broughtdown Store Wise</a>
              </router-link>
            </li>
            <li>
              <router-link to="/fiscalYearSettledReport" v-if="this.$store.getters.modules.includes('5.21')">
                <a href="#">Fiscal Year Settled Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/balanceCarryOverReport" v-if="this.$store.getters.modules.includes('5.22')">
                <a href="#">Fiscal Year Broughtdown Report</a>
              </router-link>
            </li>
            <li>
              <router-link to="/autoSettelTransaction" v-if="this.$store.getters.modules.includes('5.24')">
                <a href="#">Auto Settle Inventory And Account</a>
              </router-link>
            </li>
            <li>
              <router-link to="/monthlyTarget" v-if="this.$store.getters.modules.includes('5.03')">
                <a href="#">Monthly Sales Target</a>
              </router-link>
            </li>
            <li>
              <router-link to="/irdsetup" v-if="this.$store.getters.modules.includes('5.36')">
                <a href="#">IRD Setup</a>
              </router-link>
            </li>
          </ul>
        </li>

          <!-- <li   v-if="this.$store.getters.modules.includes('5.04')">
          <a href="#">
            Master Setup
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>
          <ul class="treeview-menu">
            <li >
              <a href="#">
                Accounting
                <span class="pull-right-container">
                 <i class="fa fa-angle-left pull-right"/>
               </span>
              </a>
            </li>
            <li  >
              <a href="#">
                Inventory
                <span class="pull-right-container">
                 <i class="fa fa-angle-left pull-right"/>
               </span>
              </a>

              <ul class="treeview-menu">
                <li>
                  <router-link to="/commision" v-if="this.$store.getters.modules.includes('5.17')">
                    <a href="#">Commision</a>
                  </router-link>
                </li>
                 <li>
                  <router-link to="/property" v-if="this.$store.getters.modules.includes('5.29')">
                    <a href="#">Item Property</a>
                  </router-link>
                </li>
                <li>
                  <router-link to="/excelUpload" v-if="this.$store.getters.modules.includes('5.23')">
                    <a href="#">Excel Upload</a>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li> -->

        <li class="treeview menu-open" v-if="this.$store.getters.modules.includes('5.03') ">
          <a href="#">
            Master Setup
            <span class="pull-right-container">
              <i class="fa fa-angle-left pull-right"/>
            </span>
          </a>

          <ul class="treeview-menu">
            <li>
              <router-link to="/excelUpload" v-if="this.$store.getters.modules.includes('5.03')">
                <a href="#">Excel Upload</a>
              </router-link>
            </li>
          </ul>
        </li>
        
        <li  class="treeview menu-open" v-if="this.$store.getters.modules.includes('5.25') || this.$store.getters.modules.includes('5.26')">
          <a href="#" >
            SMS
            <!-- <span class="treeview-title">Sms</span> -->
            <span class="pull-right-container">
             <i class="fa fa-angle-left pull-right"></i>
           </span>
          </a>
              <ul class="treeview-menu">
                <li>
                  <router-link to="/sendSms" v-if="this.$store.getters.modules.includes('5.25')">
                    <a href="#">Send SMS</a>
                  </router-link>
                </li>
                <li>
                  <router-link to="/smsReport" v-if="this.$store.getters.modules.includes('5.26')">
                    <a href="#">SMS QUEUE Report</a>
                  </router-link>
                </li>
                   <li>
                  <router-link to="/smsFailedReport" v-if="this.$store.getters.modules.includes('5.27')">
                    <a href="#">SMS Failed Report</a>
                  </router-link>
                </li>
                   <li>
                  <router-link to="/smsSentReport" v-if="this.$store.getters.modules.includes('5.28')">
                    <a href="#">SMS Sent Report</a>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
</template>
<script>
export default {
  name: 'SidebarMenu',
  methods: {
    sidebarJS() {
      var sidebarHead = document.querySelector('.sidebar-menu')
      var navBarPrts = document.querySelectorAll('.sidebar-menu > .treeview > a')
      var innerAtags = document.querySelectorAll('.sidebar-menu > .treeview > .treeview-menu > .treeview > a')
      var innerLinks = document.querySelectorAll('.sidebar-menu > .treeview > .treeview-menu > .treeview > ul > li > a')

      function commonEvt(elem) {
        var tagLI = elem.parentElement
        var tagUL = elem.nextElementSibling
        if (elem.classList.contains('active')) {
          if (elem.classList.contains('treeview-link')) {
            clearAll(sidebarHead)
          } else {
            elem.classList.remove('active')
            tagLI.classList.remove('active')
            tagUL.classList.remove('menu-open')
          }
        } else {
          if (elem.classList.contains('treeview-link')) {
            clearAll(sidebarHead)
          } else {
            clearAll(elem.parentElement.parentElement)
          }
          elem.classList.add('active')
          tagLI.classList.add('active')
          if (tagUL) {
            tagUL.classList.add('menu-open')
          }
        }
      }
      innerLinks.forEach(function (innerLink) {
        innerLink.addEventListener('click', function () {
          clearAll(sidebarHead)
        })
      })
      function clearAll(elem) {
        let allAs = elem.querySelectorAll('a')
        let allLis = elem.querySelectorAll('li')
        let allUls = elem.querySelectorAll('ul')

        document.body.classList.remove('sidebar-open')

        allAs.forEach(function (allA) {
          allA.classList.remove('active')
        })
        allLis.forEach(function (allLi) {
          allLi.classList.remove('active')
        })
        allUls.forEach(function (allUl) {
          allUl.classList.remove('menu-open')
        })
      }

      function addOrRemove(elems) {
        elems.forEach(function (elem) {
          elem.addEventListener('click', function (e) {
            e.stopPropagation()
            commonEvt(this)
            var childElements

            if (this.classList.contains('treeview-link')) {
              childElements = this.nextElementSibling
            } else {
              childElements = this.parentElement.parentElement
            }

            if (window.innerWidth > 768) {
              setTimeout(() => {
                if (childElements.getBoundingClientRect !== undefined || childElements.getBoundingClientRect !== null) {
                  console.log('childElements.getBoundingClientRect' + childElements.getBoundingClientRect)
                  var childElementsTop = childElements.getBoundingClientRect().bottom
                }
                var viewportTop = (window.innerHeight) - 150
                if (childElementsTop > viewportTop) {
                  childElements.style.top = (40 - (childElements.getBoundingClientRect().height / 2)) + 'px'
                } else {
                  childElements.style.top = 0 + 'px'
                }
              }, 300)
            }
          })
        })
      }
      addOrRemove(navBarPrts)
      addOrRemove(innerAtags)
    }
  },
  mounted: function() {
    this.$nextTick(function () {
      this.sidebarJS()
    })
  },
  updated: function() {
    this.$nextTick(function () {
      this.sidebarJS()
    })
  }
}
</script>
<style>
/* override default */
.sidebar-menu > li > a {
  padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
  animation-name: rotate;
  animation-duration: 0.3s;
  animation-fill-mode: forwards;
}

.treeview-title {
  z-index: 1;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?0b180666